module.exports = __webpack_public_path__ + "static/media/emoji-low-score-2x.389b963e.png";